/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Not_SyncedInputs */

const cs_projects_not_synced = /** @type {(inputs: Projects_Not_SyncedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nesynchronizováno`)
};

const en_projects_not_synced = /** @type {(inputs: Projects_Not_SyncedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not synced`)
};

/**
* | output |
* | --- |
* | "Not synced" |
*
* @param {Projects_Not_SyncedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_not_synced = /** @type {((inputs?: Projects_Not_SyncedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Not_SyncedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_not_synced(inputs)
	return cs_projects_not_synced(inputs)
});